
import React, { useMemo, useState } from "react";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import config from "../../../config";
import MDSnackbar from "components/MDSnackbar";
import axios from "axios";

const ElstatInputsForm = () => {
      const API_TOKEN = config.MAP_MATCHING_API_TOKEN;
      const API_URL = config.MAP_MATCHING_API_URL;
  // same islandTypes list style as in Accidents :contentReference[oaicite:1]{index=1}
  const islandTypes = [
    { id: 1, name: "Ρόδος" },
    { id: 2, name: "Κως" },
    { id: 3, name: "Κάλυμνος" },
    { id: 4, name: "Λέρος" },
    { id: 5, name: "Κάρπαθος" },
    { id: 6, name: "Κάσος" },
    { id: 7, name: "Πάτμος" },
    { id: 8, name: "Αστυπάλαια" },
    { id: 9, name: "Νίσυρος" },
    { id: 10, name: "Τήλος" },
    { id: 11, name: "Σύμη" },
    { id: 12, name: "Χάλκη" },
    { id: 13, name: "Λειψοί" },
    { id: 14, name: "Μεγίστη" },
    { id: 15, name: "Αγαθονήσι" },
    { id: 16, name: "Σύρος" },
    { id: 100, name: "Περιφέρεια Νοτίου Αιγαίου" },
    { id: 111, name: "Ελλάδα" },
    { id: 112, name: "Ε.Ε" },
  ];
  const [successSB, setSuccessSB] = useState(false);
  const [errorSB, setErrorSB] = useState(false);
  const openSuccessSB = () => setSuccessSB(true);
  const closeSuccessSB = () => setSuccessSB(false);
  const openErrorSB = () => setErrorSB(true);
  const closeErrorSB = () => setErrorSB(false);
  const currentYear = new Date().getFullYear();
  const yearOptions = useMemo(() => {
    const years = [];
    for (let y = 2015; y <= currentYear; y += 1) years.push(y);
    return years;
  }, [currentYear]);

  const [form, setForm] = useState({
    islandId: "",
    year: currentYear,
    permanentResidents: 0,
    tourists: 0,
    avgTouristNights: 0,
    totalAccidents: 0,
    totalDeaths: 0,
      mortalityIndex: 0, 
  });

    function bringSuccessNotification() {
      return (
        <MDSnackbar
          color="success"
          icon="check"
          title="Εισαγωγή Δεδομένων Ειδοποίηση"
          content="Επιτυχής εισαγωγή δεδομένων"
          dateTime={new Date().toLocaleTimeString()}
          open={successSB}
          onClose={closeSuccessSB}
          close={closeSuccessSB}
          bgWhite
        />
      );
    }
  
    function bringErrorNotification() {
      return (
        <MDSnackbar
          color="error"
          icon="warning"
          title="Εισαγωγή Δεδομένων Ειδοποίηση"
          content="Αποτυχία Εισαγωγή δεδομένων"
          dateTime={new Date().toLocaleTimeString()}
          open={errorSB}
          onClose={closeErrorSB}
          close={closeErrorSB}
          bgWhite
        />
      );
    }
  const HIDE_DEMOGRAPHICS_FOR = new Set([100, 111, 112]);

const hideDemographics = HIDE_DEMOGRAPHICS_FOR.has(Number(form.islandId));

  const handleNumberChange = (key) => (e) => {
    const raw = e.target.value;
    // allow empty, otherwise clamp to >= 0
    const value = raw === "" ? "" : Math.max(0, Number(raw));
    setForm((prev) => ({ ...prev, [key]: value }));
  };


const baseRequired =
  form.islandId !== "" &&
  form.year !== "" &&
  form.totalAccidents !== "" &&
  form.totalDeaths !== "" &&
  form.mortalityIndex !== "";   

const demographicsRequired = !hideDemographics
  ? form.permanentResidents !== "" &&
    form.tourists !== "" &&
    form.avgTouristNights !== ""
  : true;

const canSubmit = baseRequired && demographicsRequired;

const payload = {
  island_id: Number(form.islandId),
  year: Number(form.year),
  permanent_residents: Number(form.permanentResidents) || null,
  tourists: Number(form.tourists) || null,
  avg_tourist_nights: Number(form.avgTouristNights) || null,
  total_accidents: Number(form.totalAccidents),
  total_deaths: Number(form.totalDeaths),
  mortality_index: Number(form.mortalityIndex),  // 👈 NEW
};

const handleSubmit = async () => {
  try {
    const payload = {
      islandId: Number(form.islandId),
      year: Number(form.year),
      permanentResidents: hideDemographics
        ? 0
        : Number(form.permanentResidents),
      tourists: hideDemographics
        ? 0
        : Number(form.tourists),
      avgTouristNights: hideDemographics
        ? 0
        : Number(form.avgTouristNights),
      totalAccidents: Number(form.totalAccidents),
      totalDeaths: Number(form.totalDeaths),
      mortalityIndex: Number(form.mortalityIndex),
    };

    const url = `${API_URL}/statistics/add`;

    await axios.post(url, payload, {
      headers: {
        accept: "*/*",
        "Content-Type": "application/json",
        "X-API-Key": API_TOKEN,
      },
    });

    openSuccessSB();
      setSuccessSB(true);
      setTimeout(() => {
           window.location.reload();
      }, 3000);

  } catch (error) {
    console.error(error);
    openErrorSB();
    setErrorSB(true);
    
  }
};

  return (
    <DashboardLayout>
      <MDBox mt={4} p={0}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={7}>
            <Card sx={{ overflow: "visible" }}>
              <MDBox p={3}>
                <MDTypography variant="h5">Εισαγωγή δεδομένων</MDTypography>
              </MDBox>

              <MDBox component="form" pb={3} px={3}>
                <Grid container spacing={3}>
                  {/* Top dropdowns: Νησί + Έτος */}
                  <Grid item xs={12} sm={6}>
                    <MDTypography component="label" variant="button" fontWeight="regular" color="text">
                      Περιοχή  *
                    </MDTypography>

                    <FormControl fullWidth variant="standard">
                      <Select
                        value={form.islandId}
                   onChange={(e) => {
                        const newIslandId = e.target.value;

                        setForm((prev) => {
                        const next = { ...prev, islandId: newIslandId };

                        if (new Set([100, 111, 112]).has(Number(newIslandId))) {
                        next.permanentResidents = "";
                        next.tourists = "";
                        next.avgTouristNights = "";
                        }

                        return next;
                        });
                        }}
                            sx={{
                                color: "#ffffff",                // selected value color
                                "& .MuiSelect-icon": {
                                    color: "#ffffff",              // arrow icon color
                                },
                                "&:before": {
                                    borderBottomColor: "rgba(255,255,255,0.4)",
                                },
                                "&:after": {
                                    borderBottomColor: "#ffffff",
                                },
                                }}
                        displayEmpty
                      >
                        <MenuItem value="">
                          <em>Επιλέξτε Περιοχή</em>
                        </MenuItem>
                        {islandTypes.map((i) => (
                          <MenuItem key={i.id} value={i.id}>
                            {i.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} >
                    <MDTypography component="label" variant="button" fontWeight="regular" color="text">
                      Έτος *
                    </MDTypography>

                    <FormControl fullWidth variant="standard">
                      <Select
                        value={form.year}
                        onChange={(e) => setForm((prev) => ({ ...prev, year: e.target.value }))}
                                                    sx={{
                                color: "#ffffff",                // selected value color
                                "& .MuiSelect-icon": {
                                    color: "#ffffff",              // arrow icon color
                                },
                                "&:before": {
                                    borderBottomColor: "rgba(255,255,255,0.4)",
                                },
                                "&:after": {
                                    borderBottomColor: "#ffffff",
                                },
                                }}
                      >
                        {yearOptions.map((y) => (
                          <MenuItem key={y} value={y}>
                            {y}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Inputs */}
                {!hideDemographics && (
                     <>
                  <Grid item xs={12} sm={6} sx={{ mt: 1 }}>
                    <MDInput
                      fullWidth
                      type="text"
                      variant="standard"
                      label="Αριθμός μόνιμων κατοίκων "
                      value={form.permanentResidents || 0}
                      onChange={handleNumberChange("permanentResidents")}
             
                    />

                  </Grid>

                  <Grid item xs={12} sm={6} sx={{ mt: 1 }}>
                    <MDInput
                      fullWidth
                      type="text"
                      variant="standard"
                      label="Αριθμός τουριστών "
                      value={form.tourists|| 0}
                      onChange={handleNumberChange("tourists")}
                     
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} sx={{ mt: 1 }}>
                    <MDInput
                      fullWidth
                      type="text"
                      variant="standard"
                      label="Μέσος όρος διανυκτερεύσεων τουριστών "
                      value={form.avgTouristNights|| 0}
                      onChange={handleNumberChange("avgTouristNights")}

                    />
                  </Grid>
                   </>
                    )}
                  <Grid item xs={12} sm={6} sx={{ mt: 1 }}>
                    <MDInput
                      fullWidth
                      type="text"
                      variant="standard"
                      label="Συνολικός αριθμός ατυχημάτων "
                      value={form.totalAccidents|| 0}
                      onChange={handleNumberChange("totalAccidents")}
             
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} sx={{ mt: 1 }}>
                    <MDInput
                      fullWidth
                      type="text"
                      variant="standard"
                      label="Συνολικός αριθμός νεκρών "
                      value={form.totalDeaths|| 0}
                      onChange={handleNumberChange("totalDeaths")}
                   
                    />
                  </Grid>
                <Grid item xs={12} sm={6}>
                <MDInput
                fullWidth
                type="text"
                variant="standard"
                label="Δείκτη Θνησιμότητας ανά 1.000.000 "
                value={form.mortalityIndex || 0}
                onChange={handleNumberChange("mortalityIndex")}
      
                sx={{ mt: 1 }}
                />
                </Grid>

                  {/* Submit */}
                  <Grid item xs={12} mt={2}>
                    <MDBox display="flex" justifyContent="flex-end">
                      <MDButton
                        variant="gradient"
                        color="info"
                        onClick={handleSubmit}
                        disabled={!canSubmit}
                        sx={{ "&.MuiButton-root": { textTransform: "capitalize !important" } }}
                      >
                        Καταχώρηση
                      </MDButton>
                    </MDBox>
                  </Grid>
                </Grid>
              </MDBox>
            </Card>
          </Grid>
           {successSB && bringSuccessNotification()}
          {errorSB && bringErrorNotification()}
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
};

export default ElstatInputsForm;